/* tslint:disable */
/* eslint-disable */

import { ReaderFragment } from "relay-runtime";
import { FragmentRefs } from "relay-runtime";
export type PdpRespSidebarButtons_viewer = {
    readonly soldHoldPdpSourcingModal: boolean | null;
    readonly " $refType": "PdpRespSidebarButtons_viewer";
};
export type PdpRespSidebarButtons_viewer$data = PdpRespSidebarButtons_viewer;
export type PdpRespSidebarButtons_viewer$key = {
    readonly " $data"?: PdpRespSidebarButtons_viewer$data;
    readonly " $fragmentRefs": FragmentRefs<"PdpRespSidebarButtons_viewer">;
};



const node: ReaderFragment = {
  "kind": "Fragment",
  "name": "PdpRespSidebarButtons_viewer",
  "type": "Viewer",
  "metadata": null,
  "argumentDefinitions": [],
  "selections": [
    {
      "kind": "ScalarField",
      "alias": "soldHoldPdpSourcingModal",
      "name": "featureFlag",
      "args": [
        {
          "kind": "Literal",
          "name": "feature",
          "value": "soldHoldPdpSourcingModal"
        }
      ],
      "storageKey": "featureFlag(feature:\"soldHoldPdpSourcingModal\")"
    }
  ]
};
(node as any).hash = '1ad749b33e60085ec5d4c3e84801b394';
export default node;
